import { HttpClient } from "../../../Shared/Http/HttpClient";
import { CreateOrEditProject } from "../Models/CreateOrEditProject";
import { ProjectVm } from "../Models/ProjectVm";
import { SelectListItem } from "../../../Shared/Models/SelectListItem";
import { InviteMember } from "../../../Shared/Models/InviteMember";
import { TripVm } from "../../Trip/Models/TripVm";
import { CreateOrEditTripVm } from "../../Trip/Models/CreateOrEditTripVm";
import { PagedResult } from "../../Search/Models/PagedResult";
import { QueryBuilder } from "../../Search/Services/QueryBuilder";

const baseUrl = "api/projects";
const ProjectService = {
  //#region Project
  /**
   *
   * @param project
   * @returns Id of the project.
   */
  async CreateProject(project: CreateOrEditProject): Promise<ProjectVm> {
    const response = await HttpClient.post<ProjectVm>(`${baseUrl}/`, project);
    return response.data;
  },

  /**
   *
   * @returns List of projects that user has access to.
   */
  async GetProjects(
    queryBuilder: QueryBuilder<ProjectVm>
  ): Promise<PagedResult<ProjectVm>> {
    const response = await HttpClient.get<PagedResult<ProjectVm>>(
      `${baseUrl}?${queryBuilder.buildAsQueryString()}`
    );
    return response.data;
  },

  /**
   *
   * @param projectId
   * @returns a project
   */
  async GetProject(projectId: string): Promise<ProjectVm> {
    const response = await HttpClient.get<ProjectVm>(`${baseUrl}/${projectId}`);
    return response.data;
  },

  //#endregion

  //#region Trip

  async AddTrip(values: CreateOrEditTripVm): Promise<TripVm> {
    const response = await HttpClient.post<TripVm>(
      `${baseUrl}/${values.projectId}/trips`,
      values
    );
    return response.data;
  },

  async GetTrips(
    projectId: string,
    queryBuilder: QueryBuilder<TripVm>
  ): Promise<PagedResult<TripVm>> {
    const response = await HttpClient.get<PagedResult<TripVm>>(
      `${baseUrl}/${projectId}/trips?${queryBuilder.buildAsQueryString()}`
    );
    return response.data;
  },

  //#endregion

  //#region Project Members
  async GetProjectMembers(
    projectId: string
  ): Promise<SelectListItem<string>[]> {
    const response = await HttpClient.get<SelectListItem<string>[]>(
      `${baseUrl}/${projectId}/members`
    );
    return response.data;
  },

  async AddProjectMember(
    userId: string,
    projectId: string
  ): Promise<SelectListItem<string>[]> {
    const response = await HttpClient.post<SelectListItem<string>[]>(
      `${baseUrl}/${projectId}/members/${userId}`
    );
    return response.data;
  },
  async AddProjectMembers(
    userIds: string[],
    projectId: string
  ): Promise<SelectListItem<string>[]> {
    const response = await HttpClient.post<SelectListItem<string>[]>(
      `${baseUrl}/${projectId}/members`,
      userIds
    );
    return response.data;
  },

  async DeleteProjectMember(
    userId: string,
    projectId: string
  ): Promise<SelectListItem<string>[]> {
    const response = await HttpClient.delete<SelectListItem<string>[]>(
      `${baseUrl}/${projectId}/members/${userId}`
    );
    return response.data;
  },

  //#endregion

  //#region

  async InviteProjectMembers(
    values: InviteMember,
    projectId: string
  ): Promise<void> {
    const response = await HttpClient.post<void>(
      `${baseUrl}/${projectId}/members/invite`,
      values
    );
    return response.data;
  },
  //#endregion
};

export { ProjectService };
